import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';

export const createUnblockGameMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'POST',
			url: (id) => `/games/unlock/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(z.null()),
		},
	});
